export const listImportances = state => state.importances.allImportances;

export const showImportance = (state, importanceId) => state.importances.allImportances.find(ob => ob.id === importanceId);

export const getTotalCount = state => state.importances.totalCount;

export const listImportancesFilters = state => state.importances.filters;
